var map = {
	"./Dream-PC-Logo-1024x1024.webp": 8166,
	"./Eurycom2-1024x389.webp": 8852,
	"./FH-Boutique-Logo-Gold-1024x682.webp": 4166,
	"./J.P-Logo-vhigh-res--1024x1024.webp": 4578,
	"./MH-Monogram-Logo-1024x1024.webp": 7845,
	"./Menarakech-Olive.webp": 3822,
	"./ProTouchStaff-1-logo-design.webp": 118,
	"./RS-logo-Blach-BG-1024x1024.webp": 3903,
	"./RS-logo-White-BG-1024x1024.webp": 8525,
	"./RS-logo-v2-White-BG-1024x410.webp": 6744,
	"./Ramadan-Moubarak-2021-1024x1024.webp": 2931,
	"./The-Tent.webp": 5467,
	"./The-tent-real-preview-by-night-768x1024.webp": 661,
	"./alien-morph-logo-1024x1024.webp": 3310,
	"./ashraf-photo-Studio-logo-1024x426.webp": 7630,
	"./bouchra-jewelery-logo-1024x683.webp": 7698,
	"./brain-storm-final-881x1024.webp": 3749,
	"./chuen-logo-1024x1024.webp": 4269,
	"./deepsea-technologies-logo-1024x1024.webp": 3403,
	"./devil-nerd-1024x576.webp": 9786,
	"./doc_crm_logo-1024x1024.webp": 4174,
	"./eurycom-1-1024x497.webp": 9148,
	"./groovy-tunes-1-1024x576.webp": 2014,
	"./jasmine-park-palissade-part1-1024x682.webp": 1301,
	"./pawsitivity-Logo-1024x1024.webp": 1735,
	"./road-dominators-Logo-1024x576.webp": 6806,
	"./shadow-soft-1024x768.webp": 5214,
	"./squirrely-solutions-logo-1024x1024.webp": 3385,
	"./sweet-caravane-logo-1024x1024.webp": 3262,
	"./the-baking-therapy-logo-1024x1024.webp": 2562
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 232;